import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=de24222a&scoped=true&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"
import style0 from "@/sass/team.scss?vue&type=style&index=0&id=de24222a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de24222a",
  null
  
)

export default component.exports